import { axiosAuth } from "./axiosApi";
import { API_PATHS } from "./constants";

export const profileData = async () => axiosAuth.get(API_PATHS.PROFILE_INFO);

export const profileChangeData = async (data) =>
  axiosAuth.patch(API_PATHS.PROFILE_INFO, data);

export const profileChangeLocation = async (data) =>
  axiosAuth.post(API_PATHS.PROFILE_LOCATION, data);
